// extracted by mini-css-extract-plugin
export default {"cover":"cover_cover__NhWl2","cover__image":"cover_cover__image__Faqth","fadeLogoIn":"cover_fadeLogoIn__Lkehs","fadeInfoUp":"cover_fadeInfoUp__6sEwl"};